import { useState } from "react";
import SiderUser from "../../components/siderbarcomponentsUser";
import { IoIosArrowBack, IoIosArrowDown } from "react-icons/io";
import logobelmira from "../../assets/images/Logobelmira.png";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

interface Truck {
  vehiculo: string;
  Conductor: string;
  CPU: string;
  Kmrecorridos: number;
  pasajerosruta: number;
  dineroruta: number;
}

const UserInitPage: Truck[] = [
  {
    vehiculo: "HGY-986",
    Conductor: "Jairo Martínez López",
    CPU: "25-feb-2025",
    Kmrecorridos: 35,
    pasajerosruta: 35,
    dineroruta: 35,
  },
  {
    vehiculo: "TIO-142",
    Conductor: "Fernando José Gómez",
    CPU: "16-abr-2025",
    Kmrecorridos: 19,
    pasajerosruta: 35,
    dineroruta: 35,
  },
  {
    vehiculo: "EDD-632",
    Conductor: "Carlos Ramírez",
    CPU: "05-mar-2025",
    Kmrecorridos: 42,
    pasajerosruta: 40,
    dineroruta: 50,
  },
  {
    vehiculo: "JKL-277",
    Conductor: "Luis Pérez",
    CPU: "12-may-2025",
    Kmrecorridos: 30,
    pasajerosruta: 28,
    dineroruta: 33,
  },
  {
    vehiculo: "RED-419",
    Conductor: "María López",
    CPU: "23-jun-2025",
    Kmrecorridos: 50,
    pasajerosruta: 45,
    dineroruta: 60,
  },
  {
    vehiculo: "RTG-988",
    Conductor: "José Castillo",
    CPU: "08-jul-2025",
    Kmrecorridos: 55,
    pasajerosruta: 48,
    dineroruta: 65,
  },
  {
    vehiculo: "JKL-963",
    Conductor: "Ana González",
    CPU: "14-ago-2025",
    Kmrecorridos: 60,
    pasajerosruta: 55,
    dineroruta: 70,
  },
];

export default function DashboardTrucks() {
  const [trucks, setTrucks] = useState<Truck[]>(UserInitPage);
  const [filter, setFilter] = useState("dia");
  const [sortField, setSortField] = useState<string | null>(null);
  const [sortAsc, setSortAsc] = useState<boolean>(true);
  const [isModaltruckOpen, setIsModalTruckOpen] = useState<boolean>(false);
  const [isModaluser, setIsModalUser] = useState<boolean>(false);
  const [nuevaTruck, setNuevaTruck] = useState<Truck>({
    vehiculo: "",
    Conductor: "",
    CPU: "",
    Kmrecorridos: 0,
    pasajerosruta: 0,
    dineroruta: 0,
  });

  const navigate = useNavigate();

  const scaleValue = (value: number, period: string): number => {
    switch (period) {
      case "semana":
        return value * 7;
      case "mes":
        return value * 30;
      case "año":
        return value * 365;
      default:
        return value;
    }
  };

  const handleSort = (field: keyof Truck) => {
    const isAscending = sortField === field ? !sortAsc : true;
    setSortField(field);
    setSortAsc(isAscending);

    const sortedTrucks = [...trucks].sort((a, b) => {
      const valueA = scaleValue(a[field] as number, filter);
      const valueB = scaleValue(b[field] as number, filter);
      return isAscending ? valueA - valueB : valueB - valueA;
    });
    setTrucks(sortedTrucks);
  };

  // Manejar cambios en el formulario
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNuevaTruck({ ...nuevaTruck, [name]: value });
  };

  // Manejar el envío del formulario
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setTrucks([...trucks, nuevaTruck]);
    setIsModalTruckOpen(false);
    setNuevaTruck({
      vehiculo: "",
      Conductor: "",
      CPU: "",
      Kmrecorridos: 0,
      pasajerosruta: 0,
      dineroruta: 0,
    });
  };

   // Manejar el envío del usuario
   const handleSubmituser = (e: React.FormEvent) => {
    e.preventDefault();   
    setIsModalUser(false);   
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <SiderUser />
      <div className="flex-1 p-6">
        <div className="flex justify-between items-center h-auto mt-2">
          <div className="flex justify-start items-center">
            <IoIosArrowBack
              className="cursor-pointer"
              onClick={() => navigate("/empresas")}
            />
            <h1 className="text-[18px] font-semibold text-textSubtitle ml-2">
              VEHICULOS VINCULADOS A 25 DE FEBRERO DE 2025
            </h1>
          </div>
          <div className="w-[200px]">
            <img src={logobelmira} className="object-cover" />
          </div>
        </div>

        <div className="flex items-end justify-between">
          <div className="w-[30%] mt-6">
            <div className="w-full h-auto p-4 rounded-lg bg-white border border-bgSecundary">
              <h2 className="text-textTitle text-[16px] font-semibold text-center">
                Vehiculos Pertenecientes a Expreso Belmira
              </h2>
            </div>
            <div className="flex space-x-4 mt-[20px] w-full">
              {["dia", "semana", "mes", "año"].map((period) => (
                <button
                  key={period}
                  onClick={() => setFilter(period)}
                  className={`px-4 py-2 rounded-md w-[120px] ${
                    filter === period
                      ? "bg-bgSecundary text-white"
                      : "bg-gray-200"
                  }`}
                >
                  {period.toUpperCase()}
                </button>
              ))}
            </div>
          </div>
         
        </div>

        <div className="mt-6 bg-white h-[70%] shadow-md overflow-auto rounded-md">
          <table className="w-full border-collapse px-4">
            <thead>
              <tr className="border-b py-4">
                <th className="py-4 pl-6 text-left text-[14px] text-textSubtitle font-semibold">
                  Vehículo
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  Conductor
                </th>
                <th className="text-center text-[14px] text-textSubtitle font-semibold">
                  CPU
                </th>
                {["Kmrecorridos", "pasajerosruta", "dineroruta"].map(
                  (field) => (
                    <th
                      key={field}
                      className="text-center text-[14px] text-textSubtitle font-semibold cursor-pointer"
                      onClick={() => handleSort(field as keyof Truck)}
                    >
                      {field === "Kmrecorridos"
                        ? "Km recorridos"
                        : field === "pasajerosruta"
                        ? "Pasajeros/ruta"
                        : "Dinero/ruta"}
                      <IoIosArrowDown className="inline ml-1" />
                    </th>
                  )
                )}
                <th className="text-center text-[14px] text-textSubtitle font-medium">
                  Ver en tiempo real
                </th>
              </tr>
            </thead>
            <tbody>
              {trucks.map((truck, index) => (
                <tr key={index} className="border-b hover:bg-gray-100 py-4">
                  <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">
                    {truck.vehiculo}
                  </td>
                  <td className="text-center text-[14px] text-textTipic font-medium">
                    {truck.Conductor}
                  </td>
                  <td className="text-center text-[14px] text-textTipic font-medium">
                    {truck.CPU}
                  </td>
                  <td className="text-center text-[14px] text-textPrimary font-medium">
                    {scaleValue(truck.Kmrecorridos, filter)}
                  </td>
                  <td className="text-center text-[14px] text-textPrimary font-medium">
                    {scaleValue(truck.pasajerosruta, filter)}
                  </td>
                  <td className="text-center text-[14px] text-textPrimary font-medium">
                    {scaleValue(truck.dineroruta, filter)}
                  </td>
                  <td
                    onClick={() => navigate("/empresas/trucks/detail")}
                    className="text-center text-[14px] text-textTipic font-medium cursor-pointer"
                  >
                    Ver en tiempo real
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>       
        
      </div>
    </div>
  );
}
